module.exports = __webpack_public_path__ + "static/media/farmdokMockAppleMobileApplicationEN.98ba4934.png";